import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/footer';
import Header from '../components/header';
import 'animate.css/animate.min.css';
const WhyChooseUs = () => {
    useEffect(() => {
        document.title = ":: Why Choose Us | Adber Infra India Pvt. Ltd. ::";
    }, []);
    return (
        <div>
            <Header />
            <section className="inner-page-banner-area why">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-8 col-sm-8 col-xs-12">
                            <div className="banner-caption contacttext">
                                <h1 className=""> Why Choose Us ? </h1>
                                <p> We pride ourselves on our selection of grades and strengths of concrete, available at extremely competitive prices. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="breadcrumbs-area">
                <div className="container-fluid">
                    <ol className="breadcrumb">
                        <li><Link to="/"> Home </Link></li>
                        <li><Link to="/about-us"> About Us </Link></li>
                        <li> Why Choose Us ? </li>
                    </ol>
                </div>
            </section>
            <main className="container" id="InternalPageArea">
                <div className="row">
                    <div className="col-sm-12 col-xs-12">
                        <p> Today, the RMC Division has grown to become the largest concrete production entity in Pune. The division has also set a singular record in the industry by achieving the largest continuous pour of concrete of 1200 M<sup>3</sup> within a 15 Hrs. </p>

                        <p className="whytxt"><span> R&D </span>
                            <span> Quality Control </span>
                            <span> Quality Assurance </span>
                        </p>

                        <p> The goal at Adber Infra India Pvt. Ltd. has always been to produce high-quality products in the most efficient way. In order to deliver that, we focus both on quality assurance as well as on quality control efforts at every stage of the process. </p>

                        <p> The entire production equipment and machinery have been procured from Putzmeister, Aquarius India,
                            Sany considered the best in concrete equipment technology. </p>

                        <p> The cement, aggregates, and admixtures used in our products, for instance, are inspected and tested for stringent quality parameters and sourced from only well-established and reputed companies. Every stage of the production process is also closely monitored and recorded. Our R&D expertise ensures that our customers are delivered the value for their money, every time. Adber Infra India Pvt. Ltd. follows IS standard design mix configurations and when required design mix can be customized to meet end-use requirements. We value-added products like self-compacting concrete, Lightweight concrete, high-performance concrete, Self-curing concrete, High-strength concrete, High-flow concrete, etc. </p>
                    </div>
                </div>
            </main>
            <section className="whyBgwrap">
                <div className="container-fluid">
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-sm-12 col-md-12 col-xs-12">
                                <div className="whyhead">
                                    <h3> Our Features </h3>
                                    <p> We pride ourselves on our selection of grades and strengths of concrete, available at extremely competitive prices. </p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6 col-md-3 col-xs-12">
                                <div className="whyWrapper wow fadeInUp">
                                    <div className="img effect-2 sub-a">
                                        <img src="../assets/images/icon/group.png" alt="Our experienced team are there to help you every step of the way." title="Our experienced team are there to help you every step of the way." />
                                    </div>
                                    <p className="why-text"> Our experienced team are there to help you every step of the way. </p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-3 col-xs-12">
                                <div className="whyWrapper wow fadeInUp">
                                    <div className="img effect-2 sub-a">
                                        <img src="../assets/images/icon/award.png" alt="The entire production equipment " title="The entire production equipment " />
                                    </div>
                                    <p className="why-text"> The entire production equipment and machinery has been procured from reputed companies, India, considered the best in concrete equipment technology. </p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-3 col-xs-12">
                                <div className="whyWrapper wow fadeInUp">
                                    <div className="img effect-2 sub-a">
                                        <img src="../assets/images/icon/on-time-punctual.png" alt="On Time Punctual Service" title="On Time Punctual Service" />
                                    </div>
                                    <p className="why-text"> On Time Punctual Service. </p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-3 col-xs-12">
                                <div className="whyWrapper wow fadeInUp">
                                    <div className="img effect-2 sub-a">
                                        <img src="../assets/images/icon/customer-service.png" alt="Our experts" title="Our experts" />
                                    </div>
                                    <p className="why-text"> Our experts can advise you on what type of material you will need. </p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-3 col-xs-12">
                                <div className="whyWrapper wow fadeInUp">
                                    <div className="img effect-2 sub-a">
                                        <img src="../assets/images/icon/quality-control.png" alt="Quality assurance as well as on quality control" title="Quality assurance as well as on quality control" />
                                    </div>
                                    <p className="why-text"> We focus both on quality assurance and on quality control efforts at every stage of the process. </p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-3 col-xs-12">
                                <div className="whyWrapper wow fadeInUp">
                                    <div className="img effect-2 sub-a">
                                        <img src="../assets/images/icon/no-wastage.png" alt="No Wastage" title="No Wastage" />
                                    </div>
                                    <p className="why-text"> No Wastage. </p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-3 col-xs-12">
                                <div className="whyWrapper wow fadeInUp">
                                    <div className="img effect-2 sub-a">
                                        <img src="../assets/images/icon/best-vehicles.png" alt="Our advanced vehicles" title="Our advanced vehicles" />
                                    </div>
                                    <p className="why-text"> Our advanced vehicles mean that your concrete is delivered straight to the site on time, every time. </p>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-3 col-xs-12">
                                <div className="whyWrapper wow fadeInUp">
                                    <div className="img effect-2 sub-a">
                                        <img src="../assets/images/icon/quantitive-prices.png" alt="Competitive Prices" title="Competitive Prices" />
                                    </div>
                                    <p className="why-text"> Competitive Prices. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}


export default WhyChooseUs;
